import { useParams } from "react-router-dom";
import GreenCardContent from "../content/GreenCardContent";

export default function GreenCard() {
    const { slug } = useParams();

    return <GreenCardContent currentPage={slug || "home"} />;
}